import { createApp } from 'vue'
import { createPinia } from 'pinia'
import Toast from 'vue-toastification'
import router from './router'
import App from './App.vue'
import { useAuthStore } from '@/stores/auth'
import { env } from '@/config/env'
import { TOAST_TIMEOUT } from '@/config/constants'

import './assets/styles/main.css'
import 'vue-toastification/dist/index.css'

// Set document title from environment
document.title = env.APP_NAME

async function initApp() {
  const app = createApp(App)
  const pinia = createPinia()

  app.use(pinia)
  app.use(router)
  app.use(Toast, {
    position: 'top-right',
    timeout: TOAST_TIMEOUT,
    closeOnClick: true,
    pauseOnFocusLoss: true,
    pauseOnHover: true,
    draggable: true,
    draggablePercent: 0.6,
    showCloseButtonOnHover: false,
    hideProgressBar: false,
    closeButton: 'button',
    icon: true,
    rtl: false
  })

  // Initialize auth store
  const authStore = useAuthStore()
  await authStore.initAuth()

  app.mount('#app')
}

initApp()